import { Badge } from "@arcadeai/design-system/components/ui/atoms/badge";

type CardStatusBadgeProps = {
  isStatic?: boolean;
  isEnabled?: boolean;
  showEnabled?: boolean;
};

export const CardStatusBadge = ({
  isStatic = false,
  isEnabled = false,
  showEnabled = false,
}: CardStatusBadgeProps) => {
  if (!(isStatic || showEnabled)) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      {isEnabled ? (
        <Badge className="bg-emerald-600 text-white text-xs hover:bg-emerald-700">
          Enabled
        </Badge>
      ) : (
        <Badge className="bg-red-500 text-white text-xs hover:bg-red-600">
          Disabled
        </Badge>
      )}
      {!!isStatic && (
        <Badge className="bg-orange-500 text-white text-xs hover:bg-orange-600">
          Static
        </Badge>
      )}
    </div>
  );
};
